@if (stationsQueryResults$ | async; as result) {
<kendo-label text="Station">
    <kendo-multiselect [data]="result.data ?? []"
                       [disabled]="isDisabled || result.isLoading"
                       [loading]="result.isLoading"
                       [placeholder]="result.isLoading ? 'Loading' : ''"
                       [virtual]="virtual"
                       [value]="value"
                       (valueChange)="handleValueChange($event)"
                       (blur)="handleBlur()"
                       textField="station"
                       valueField="station">
        <ng-template kendoComboBoxItemTemplate let-dataItem>
            {{ formattingService.formatStation(dataItem.station, dataItem.stateProvince) }}
        </ng-template>
    </kendo-multiselect>
</kendo-label>
}
